import { useState } from "react";
import { message } from "antd";
import { useTranslation } from "react-i18next";
import {
  User,
  UserCreatePayload,
} from "types/superAdmin/userTypes";
import {
  createUser,
  deleteUser,
} from "services/superAdmin/userService";
import useInstances from "./useInstances";
import { findOneByEmailAndRole, sendResetPassword } from "services/userService";


export const useUsers = () => {
  const { t } = useTranslation();

  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  // UI state
  const [selectedUser, setSelectedUser] = useState<User | null>(null);
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const { fetchInstances } = useInstances();



  /**
   * Create a new user
   */
  const handleCreate = async (payload: UserCreatePayload) => {
    try {
      await createUser(payload);
      message.success(t("user_created_successfully"));
      await fetchInstances();
      return true;
    } catch (err) {
      console.error(err);
      return false;
    }
  };

  /**
   * Delete a user
   */
  const handleDelete = async (userId: string) => {
    try {
      await deleteUser(userId);
      message.success(t("user_deleted_successfully"));
      await fetchInstances();
      return true;
    } catch (err) {
      console.error(err);
      return false;
    }
  };

  const triggerResetPassword = async (body: { user_id?: string; type: "email" | "sms" }) => {
    try {
      const response = await sendResetPassword(body);
      const messageSuccess = (body.type == "email" ? t("reset_password_via_email_success") : t("reset_password_via_sms_success"));
      message.success(messageSuccess);
      return response
    } catch (err) {
      return false
    }
  };

  const handleFindOneByEmailAndRole = async (params: any) => {
    try {
      console.log("paramsparamsparams",params)
      const response = await findOneByEmailAndRole(params);
      return response
    } catch (err) {
      console.log("err", err);
      return false
    }
  };

  return {
    loading,
    error,
    selectedUser,
    setSelectedUser,
    isModalOpen,
    setIsModalOpen,
    handleCreate,
    handleDelete,
    triggerResetPassword,
    handleFindOneByEmailAndRole
  };
};

export default useUsers;
